import { RowEditAndDelete } from 'components/icons/RowEditAndDelete';

export const columnsDataForecast = [
	{
		Header: ' ',
		accessor: 'CheckBox',
		disableSortBy: true,
		type: 'checkBox',
		filter: false,
	},
	{
		Header: 'Cód.',
		accessor: 'codigoForecast',
		type: 'number',
		optional: true,
		filter: 'includesIgnoreCase',
		hover: 'Código do Forecast',
	},
	{
		Header: 'Seq.',
		accessor: 'sequenciaCodigoForecast',
		type: 'number',
		optional: true,
		filter: 'includesIgnoreCase',
		hover: 'Sequência do Código do Forecast',
	},
	{
		Header: 'Competência',
		accessor: 'competencia',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Canal de Venda',
		accessor: 'canalVenda',
		type: 'nullableTag',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Cliente',
		accessor: 'cliente',
		type: 'nullableTag',
		optional: true,
		createable: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Receita Bruta',
		accessor: 'receitaBruta',
		type: 'money',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: 'Data Registro',
		accessor: 'dataRegistro',
		type: 'date',
		optional: true,
		filter: 'includesIgnoreCase',
	},
	{
		Header: ' ',
		type: 'jsx',
		accessor: 'button',
		filter: false,
		jsx: RowEditAndDelete,
	},
];
